import React from 'react'

/**
 * MapPin svg icon.
 */
const MapPin = () => (
  <svg width="35" height="42" viewBox="0 0 35 42.63" xmlns="http://www.w3.org/2000/svg">
    <g>
      <g>
        <path d="M25,0H10L0,9.88V25L17.5,42.63,35,25V10Zm7,23.8L17.5,38.37,3,23.8V11.12L11.2,3H23.8L32,11.2Z" />
        <path d="M17.5,10A7.5,7.5,0,1,0,25,17.5,7.5,7.5,0,0,0,17.5,10Zm0,12A4.5,4.5,0,1,1,22,17.5,4.51,4.51,0,0,1,17.5,22Z" />
      </g>
    </g>
  </svg>
)

export default MapPin
